<template>
  <div class="flex-1" style=" padding-right:30px">
    <el-form :model="formData" :rules="formRules" ref="formMainRef" label-width="130px">
      <!-- 违章签收 -->
      <el-row>
        <div class="mb-30px">
          <span class="border-l-2 border-blue-500 pl-10px text-16px">{{ $t('违章签收') }}</span>
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="`${$t('签收人')}`" prop="signeeId">
              <person-select
                v-model="formData.signeeId"
                @sentData="changePersonSelect($event, 'signee')"
                :disabled="IsDiaable('signeeId')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="`${$t('签收单位')}`" prop="signeeOrgId">
              <el-select
                size="small"
                style="width: 100%;"
                v-model="formData.signeeOrgId"
                :disabled="signeeOrgList.length < 2 || IsDiaable('signeeOrgId')"
                placeholder="自动获取"
              >
                <el-option
                  v-for="item in signeeOrgList"
                  :key="item.organizationUnitId"
                  :label="item.organizationUnitName"
                  :value="item.organizationUnitId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
      <!-- 违章整改 -->
      <el-row v-if="chapterVis('rectification')">
        <div class="mb-30px">
          <span class="border-l-2 border-blue-500 pl-10px text-16px">{{ $t('违章整改') }}</span>
          <el-button
            type="primary"
            @click="delayHistoryVis = true"
            class="ml-30px"
            v-if="delayRecordList.length"
            >整改延期历史</el-button
          >
          <el-switch v-model="formData.rectification" class="ml-40px" v-if="SwitchVis"></el-switch>
        </div>
        <div v-if="formData.rectification">
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('整改责任人')}`" prop="rectRespPersonId">
                <person-select
                  v-model="formData.rectRespPersonId"
                  @sentData="changePersonSelect($event, 'rectRespPersonName')"
                  :disabled="IsDiaable('rectRespPersonId')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('整改责任单位')}`" prop="rectRespOrgId">
                <el-select
                  size="small"
                  style="width: 100%;"
                  v-model="formData.rectRespOrgId"
                  :disabled="signeeOrgList.length < 2 || IsDiaable('rectRespOrgId')"
                  placeholder="自动获取"
                >
                  <el-option
                    v-for="item in rectRespOrgList"
                    :key="item.organizationUnitId"
                    :label="item.organizationUnitName"
                    :value="item.organizationUnitId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('整改期限')}`" prop="rectDeadline">
                <el-date-picker
                  type="date"
                  :disabled="IsDiaable('rectDeadline')"
                  style="width: 100%;"
                  v-model="formData.rectDeadline"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('验收人')}`" prop="acceptedById">
                <person-select
                  v-model="formData.acceptedById"
                  @sentData="changePersonSelect($event, 'acceptedByName')"
                  :disabled="IsDiaable('acceptedById')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item :label="`${$t('整改要求')}`" prop="rectRequirements">
                <el-input
                  style="width: 100%;"
                  size="small"
                  :placeholder="`${$t('请输入')}`"
                  v-model="formData.rectRequirements"
                  :disabled="IsDiaable('rectRequirements')"
                  clearable
                  :maxlength="200"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="isShowRect">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="`${$t('整改完成情况')}`" prop="rectSituation">
                  <el-input
                    style="width: 100%;"
                    size="small"
                    type="textarea"
                    :placeholder="`${$t('请输入')}`"
                    v-model="formData.rectSituation"
                    :disabled="IsDiaable('rectSituation')"
                    clearable
                    show-word-limit
                    :maxlength="500"
                    :autosize="{ minRows: 2 }"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="`${$t('整改图片')}`" prop="pictures">
                  <uploadCom
                    ref="uploadComMain"
                    :fileTypeList="fileTypeList"
                    @update:file="updateFile"
                    :fileMaxSize="20"
                    :fileNum="9"
                    :disabled="IsDiaable('pictures')"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="`${$t('整改完成日期')}`" prop="finishedDate">
                  <el-date-picker
                    type="date"
                    :disabled="IsDiaable('finishedDate')"
                    style="width: 100%;"
                    v-model="formData.finishedDate"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-row>
      <!-- 违章处罚 -->
      <el-row v-if="chapterVis('penalty')">
        <div class="mb-30px">
          <span class="border-l-2 border-blue-500 pl-10px text-16px">{{ $t('违章处罚') }}</span>
          <el-switch v-if="SwitchVis" v-model="formData.penalty" class="ml-40px"></el-switch>
        </div>
        <div v-if="formData.penalty">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('处罚依据')}`" prop="penaltyBasis">
                <el-autocomplete
                  v-model="formData.penaltyBasis"
                  :disabled="IsDiaable('penaltyBasis')"
                  :fetch-suggestions="querySearch"
                  :placeholder="`${$t('请输入')}`"
                  style="width: 100%;"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  type="textarea"
                  :maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 2 }"
                >
                  <template slot-scope="{ item }">
                    <div>{{ item.penaltyBasis }}</div>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('处罚人员')}`" prop="punishPersonnel">
                <el-input
                  size="small"
                  v-model="formData.punishPersonnel"
                  placeholder="请选择"
                  style="flex:1"
                  :disabled="IsDiaable('punishPersonnel')"
                  readonly
                >
                  <template slot="append">
                    <el-button
                      type="primary"
                      :disabled="IsDiaable('punishPersonnel')"
                      @click="openMenDia('punishPersonnel')"
                      >选择</el-button
                    >
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('违章扣分')}`" prop="penaltyScore">
                <el-input-number
                  style="width: 100%;"
                  size="small"
                  :placeholder="`${$t('请输入')}`"
                  v-model="formData.penaltyScore"
                  :disabled="IsDiaable('penaltyScore')"
                  clearable
                  :max="100"
                  :precision="2"
                  :min="0"
                  :controls="false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('处罚金额')}`" prop="penaltyAmount">
                <el-input-number
                  style="width: 100%;"
                  size="small"
                  :placeholder="`${$t('请输入')}`"
                  v-model="formData.penaltyAmount"
                  :disabled="IsDiaable('penaltyAmount')"
                  clearable
                  :precision="2"
                  :min="0"
                  :max="1000000"
                  :controls="false"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('教育培训(h)')}`" prop="trainHour">
                <el-input-number
                  style="width: 100%;"
                  size="small"
                  :placeholder="`${$t('请输入')}`"
                  v-model="formData.trainHour"
                  :disabled="IsDiaable('trainHour')"
                  clearable
                  :max="200"
                  :precision="2"
                  :min="0"
                  :controls="false"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div>
            <div
              class="text-center add-related-btn"
              @click="openLinkPeo"
              v-if="isShowLinkPeopleBtn"
            >
              + 新增联责人员
            </div>
            <div class="relative" v-if="isShowLinkPeople">
              <div class="add-related-line"></div>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="`${$t('联责人员')}`" prop="responsiblePersonnel">
                    <el-input
                      size="small"
                      v-model="formData.responsiblePersonnel"
                      placeholder="请选择"
                      style="flex:1"
                      disabled
                      readonly
                    >
                      <template slot="append">
                        <el-button
                          :disabled="IsDiaable('responsiblePersonnel')"
                          @click="openMenDia('responsiblePersonnel')"
                          >选择</el-button
                        >
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="`${$t('违章扣分')}`" prop="responsibleScore">
                    <el-input-number
                      style="width: 100%;"
                      size="small"
                      :placeholder="`${$t('请输入')}`"
                      v-model="formData.responsibleScore"
                      clearable
                      :maxlength="20"
                      :precision="0"
                      :min="0"
                      :max="100"
                      :controls="false"
                      :disabled="IsDiaable('responsiblePersonnel')"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="`${$t('处罚金额')}`" prop="responsibleAmount">
                    <el-input-number
                      style="width: 100%;"
                      size="small"
                      :placeholder="`${$t('请输入')}`"
                      v-model="formData.responsibleAmount"
                      clearable
                      :precision="2"
                      :min="0"
                      :max="1000000"
                      :controls="false"
                      :disabled="IsDiaable('responsiblePersonnel')"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="`${$t('教育培训(h)')}`" prop="responsibleTrainHour">
                    <el-input-number
                      style="width: 100%;"
                      size="small"
                      :placeholder="`${$t('请输入')}`"
                      v-model="formData.responsibleTrainHour"
                      :disabled="IsDiaable('responsiblePersonnel')"
                      clearable
                      :maxlength="20"
                      :precision="2"
                      :min="0"
                      :max="200"
                      :controls="false"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <i
                class="absolute el-icon-delete -right-20px top-70px text-hex-red"
                v-if="!IsDiaable('responsiblePersonnel')"
                @click="closeLinkPeo"
              ></i>
            </div>
          </div>
        </div>
      </el-row>
      <!-- 违章奖励 -->
      <el-row v-if="chapterVis('rewards')">
        <div class="mb-30px">
          <span class="border-l-2 border-blue-500 pl-10px text-16px">{{ $t('违章奖励') }}</span>
          <el-switch v-model="formData.rewards" class="ml-40px" v-if="SwitchVis"></el-switch>
        </div>
        <div v-if="formData.rewards">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('奖励依据')}`" prop="rewardBasis">
                <el-autocomplete
                  v-model="formData.rewardBasis"
                  :disabled="IsDiaable('rewardBasis')"
                  :fetch-suggestions="queryRewardSearch"
                  :placeholder="`${$t('请输入')}`"
                  style="width: 100%;"
                  :trigger-on-focus="false"
                  @select="rewardHandleSelect"
                  type="textarea"
                  :maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 2 }"
                >
                  <template slot-scope="{ item }">
                    <div>{{ item.rewardBasis }}</div>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('奖励人员')}`" prop="rewardPersonnel">
                <el-input
                  size="small"
                  v-model="formData.rewardPersonnel"
                  placeholder="请选择"
                  style="flex:1"
                  :disabled="IsDiaable('rewardPersonnel')"
                  readonly
                >
                  <template slot="append">
                    <el-button
                      type="primary"
                      :disabled="IsDiaable('rewardPersonnel')"
                      @click="openMenDia('rewardPersonnel')"
                      >选择</el-button
                    >
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('奖励积分')}`" prop="rewardScore">
                <el-input-number
                  style="width: 100%;"
                  size="small"
                  :disabled="IsDiaable('rewardScore')"
                  :placeholder="`${$t('请输入')}`"
                  v-model="formData.rewardScore"
                  clearable
                  :max="100"
                  :precision="2"
                  :min="0"
                  :controls="false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('奖励金额(元)')}`" prop="rewardAmount">
                <el-input-number
                  style="width: 100%;"
                  size="small"
                  :placeholder="`${$t('请输入')}`"
                  :disabled="IsDiaable('rewardAmount')"
                  v-model="formData.rewardAmount"
                  clearable
                  :max="1000000"
                  :precision="2"
                  :min="0"
                  :controls="false"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </el-form>
    <PersonManySelect
      :visible.sync="showSelectDialog"
      :selectedPersonList="currentPersonList"
      v-if="showSelectDialog"
      @getSelectedList="getPersonList"
    />
    <DelayRecords
      :visible.sync="delayHistoryVis"
      v-if="delayHistoryVis"
      :delayRecordList="delayRecordList"
    />
  </div>
</template>

<script>
import { ViolationConfigApi, ViolationRecordApi } from '@wiz-api/personnel-safety-management'
import uploadCom from '@/components/safety/WizSafetyPage/safetyFactor/uploadCom'
import dayjs from 'dayjs'
import { disappearList } from '@/components/safety/WizSafetyPage/violation/enums'

const violationRecordApi = new ViolationRecordApi()
const violationConfigApi = new ViolationConfigApi()

const PersonSelect = () => {
  return import('@/components/safety/FormSelect/PersonSelect')
}
const PersonManySelect = () => {
  return import('@/components/safety/WizSafetyPage/safetyFactor/SelectPeople')
}
const DelayRecords = () => {
  return import('@/components/safety/WizSafetyPage/violation/DelayRecords')
}

export default {
  name: 'violation-main-info',
  components: { uploadCom, PersonSelect, PersonManySelect, DelayRecords },
  props: {
    propsStatus: {
      type: Number,
      default: 0,
    },
    operateType: {
      default: '',
      type: String,
    },
    operateFormat: {
      type: Object,
      default: () => {
        return {}
      },
    },
    restaurants: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      status: this.$route.query.status || this.propsStatus,
      fileTypeList: ['jpg', 'jpeg', 'png', 'bmp'],
      showSelectDialog: false, // 选择多人弹窗
      isShowLinkPeople: false,
      isShowLinkPeopleBtn: false,
      signeeOrgList: [],
      rectRespOrgList: [],
      currentPersonList: [],
      formRules: {},
      personList: {
        punishPersonnel: [],
        responsiblePersonnel: [],
        rewardPersonnel: [],
      },
      singerMen: '',
      timeLimit: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        },
        selectableRange: '00:00:00 - 23:59:59',
      },
      Informant: '',
      formInstanceId: '',
      formData: {
        signeeId: undefined,
        id: undefined,
        signee: '',
        signeeOrgId: undefined,
        signeeOrgName: '',
        signingTime: '',
        recordId: '',
        rectRespPersonId: undefined,
        rectRespPersonName: '',
        rectRespOrgId: undefined,
        rectRespOrgName: '',
        rectDeadline: '',
        acceptedById: undefined,
        acceptedByName: '',
        acceptedTime: '',
        rectRequirements: '',
        rectSituation: '',
        pictures: '',
        finishedDate: '',
        penaltyBasis: '',
        penaltyScore: undefined,
        penaltyAmount: undefined,
        trainHour: undefined,
        punishPersonnel: '',
        responsiblePersonnel: '',
        responsibleScore: undefined,
        responsibleAmount: undefined,
        responsibleTrainHour: undefined,
        rewardBasis: '',
        rewardScore: undefined,
        rewardAmount: undefined,
        rewardPersonnel: '',
        rectification: true,
        penalty: true,
        rewards: true,
      },
      delayHistoryVis: false,
      showMenType: '',
      openChapter: { rectification: true, penalty: true, rewards: true },
      delayRecordList: [],
    }
  },
  created() {
    if (this.$route.query.operateType === 'vioExamine') {
      this.isShowLinkPeopleBtn = true
    }
    const self = this
    this.reFreshChapter()
    const formRules = {}
    this.operateFormat.reqMust?.forEach((item) => {
      formRules[item] = [
        { required: true, message: self.$t('请输入'), trigger: ['blur', 'change'] },
      ]
    })
    this.formRules = formRules
  },
  computed: {
    // 违章整改要求显示
    isShowRect() {
      if (['3', '4', '5'].includes(this.status)) {
        return true
      }
      if (['6', '7'].includes(this.status) && this.formData.rectSituation) {
        return true
      }
      return false
    },
    chapterVis() {
      return (name) => {
        if (Number(this.status) > 1) {
          return this.formData[name]
        }
        if (this.formData.id !== '00000000-0000-0000-0000-000000000000' && this.formData.id) {
          return this.formData[name]
        }
        return this.openChapter[name]
      }
    },
    SwitchVis() {
      if (this.$route.path == '/contractor-management/person-files') {
        return false
      }
      if (Number(this.status) > 1 || this.$route.query.operateType === 'vioExamineInfo') {
        return false
      }
      return true
    },
  },

  methods: {
    // 处罚搜索
    async querySearch(queryString, cb) {
      const restaurants = this.restaurants
      const results = queryString
        ? restaurants.filter((item) => {
            if (item.penaltyBasis) {
              return item.penaltyBasis.indexOf(queryString) >= 0
            }
            return false
          })
        : restaurants
      cb(results)
    },
    // 处罚筛选
    handleSelect(item) {
      this.formData.trainHour = item.trainHour
      this.formData.penaltyAmount = item.penaltyAmount
      this.formData.penaltyScore = item.penaltyScore
      this.formData.penaltyBasis = item.penaltyBasis
    },
    // 奖励搜索
    async queryRewardSearch(queryString, cb) {
      const restaurants = this.restaurants
      const results = queryString
        ? restaurants.filter((item) => {
            if (item.rewardBasis) {
              return item.rewardBasis.indexOf(queryString) >= 0
            }
            return false
          })
        : restaurants
      cb(results)
    },
    // 处罚筛选
    rewardHandleSelect(item) {
      this.formData.rewardScore = item.rewardScore
      this.formData.rewardAmount = item.rewardAmount
      this.formData.rewardBasis = item.rewardBasis
    },
    // 则连筛选
    rePubnishSelect(item) {
      this.isShowLinkPeople = true
      this.isShowLinkPeopleBtn = false
      this.formData.responsibleScore = item.relationPenaltyScore
      this.formData.responsibleTrainHour = item.relationTrainHour
      this.formData.responsibleAmount = item.relationPenaltyAmount
    },
    // 打开则连人员
    openLinkPeo() {
      this.isShowLinkPeople = true
      this.isShowLinkPeopleBtn = false
    },
    // 关闭则连人员
    closeLinkPeo() {
      this.isShowLinkPeople = false
      this.isShowLinkPeopleBtn = true
    },
    // 文件显示
    updateFile(val) {
      if (val.length) {
        this.formData.pictures = JSON.stringify(val)
      } else {
        this.formData.pictures = ''
      }
    },
    // 违章延期记录
    async getDelayRecords() {
      if (Number(this.status) < 3) return
      const [err, res] = await violationRecordApi.getDelayRecordList({
        recordId: this.formData.recordId,
      })
      if (err) return
      this.delayRecordList = res
    },
    // 详情回显
    detailShow(data) {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = data[key]
        if (
          ['rewardPersonnel', 'punishPersonnel', 'responsiblePersonnel'].includes(key) &&
          data[key]
        ) {
          this.showMenType = key
          this.getPersonList(JSON.parse(data[key]))
        }
        if (key === 'signeeOrgId') {
          this.signeeOrgList = [
            { organizationUnitId: data[key], organizationUnitName: data.signeeOrgName },
          ]
        }
        if (key === 'rectRespOrgId') {
          this.rectRespOrgList = [
            { organizationUnitId: data[key], organizationUnitName: data.rectRespOrgName },
          ]
        }
      })

      this.isShowLinkPeople = this.formData.responsiblePersonnel ? true : false

      if (
        (this.formData.id === '00000000-0000-0000-0000-000000000000' || !this.formData.id) &&
        this.$route.query.operateType === 'violationAudit'
      ) {
        this.isShowLinkPeopleBtn = true
      }

      this.$nextTick(() => {
        if (this.formData.pictures) {
          this.$refs.uploadComMain?.setFile(JSON.parse(this.formData.pictures))
        }
        this.$refs.formMainRef.clearValidate()
      })
      console.log(this.formData)
      this.getDelayRecords()
    },
    // 获取章节
    async reFreshChapter() {
      const [err, res] = await violationConfigApi.getStandardConfig()
      if (err) return
      this.openChapter = res
    },
    // 是否可编辑
    IsDiaable(prop) {
      if (this.operateFormat.limitType === 'allDisabled') {
        return true
      }
      if (this.operateFormat.limitType === 'allAgree') {
        return false
      }
      if (this.operateFormat.props.includes(prop)) {
        return this.operateFormat.limitType === 'disabled'
      }
      return !(this.operateFormat.limitType === 'disabled')
    },
    // 是否详情页
    openMenDia(type) {
      this.showMenType = type
      this.currentPersonList = this.personList[type]
      this.showSelectDialog = true
    },
    /**
     * @description 获取人员列表
     * @param {Array} personList 已选择人员列表
     */
    getPersonList(personList) {
      this.personList[this.showMenType] = personList.map((item) => {
        return {
          name: item.name,
          keyId: item.keyId,
          id: item.id,
          orgId: item.organizationUnitId,
          orgName: item.organizationUnitName,
        }
      })
      this.formData[this.showMenType] = personList.reduce((pre, cur, index) => {
        pre += cur.name + (index === personList.length - 1 ? '' : ',')
        return pre
      }, '')
    },
    // 返回选择人员的id
    changePersonSelect(data, type) {
      this.formData[type] = data.name
      if (type === 'signee') {
        this.signeeOrgList = data.orgUnits
        if (data.orgUnits.length === 1) {
          this.formData.signeeOrgId = data.orgUnits[0].organizationUnitId
        }
      } else if (type === 'rectRespPersonName') {
        this.rectRespOrgList = data.orgUnits
        if (data.orgUnits.length === 1) {
          this.formData.rectRespOrgId = data.orgUnits[0].organizationUnitId
        }
      }
    },
    async submitData() {
      const self = this
      await this.$refs.formMainRef.validate()
      const params = {
        ...this.formData,
      }
      // 第一次判断章节不显示
      if (!this.$route.query.id || this.formData.id === '00000000-0000-0000-0000-000000000000') {
        Object.keys(this.openChapter).forEach((key) => {
          if (!this.openChapter[key]) {
            params[key] = false
          }
        })
      }

      // 下拉框
      if (params.signeeOrgId) {
        const val = this.signeeOrgList.find((item) => {
          return item.organizationUnitId === params.signeeOrgId
        })
        params.signeeOrgName = val?.organizationUnitName
      }
      if (params.rectRespOrgId) {
        const val = this.rectRespOrgList.find((item) => {
          return item.organizationUnitId === params.rectRespOrgId
        })
        params.rectRespOrgName = val?.organizationUnitName
      }

      const personParams = ['punishPersonnel', 'responsiblePersonnel', 'rewardPersonnel']
      const timeParams = ['signingTime', 'acceptedTime', 'rectDeadline', 'finishedDate']
      const showCharter = ['rectification', 'penalty', 'rewards']
      // 人员
      personParams.forEach((item) => {
        if (params[item]) {
          params[item] = JSON.stringify(self.personList[item])
        }
      })
      // 时间
      timeParams.forEach((key) => {
        if (params[key]) {
          params[key] = dayjs(params[key]).format('YYYY-MM-DD HH:mm:ss')
        } else {
          params[key] = null
        }
      })
      // 章节
      showCharter.forEach((key) => {
        if (!params[key]) {
          disappearList[key].forEach((item) => {
            params[item] = null
          })
        }
      })
      // 责联人员
      const linkpeo = [
        'responsiblePersonnel',
        'responsibleScore',
        'responsibleAmount',
        'responsibleTrainHour',
      ]
      if (!this.isShowLinkPeople) {
        linkpeo.forEach((key) => {
          params[key] = null
        })
      }

      this.$emit('finallySub', params)
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
.add-related-btn {
  border: 1px dashed var(--lineBorderColor);
  color: 1px dashed var(--lineBorderColor);
  margin: 0 0 20px 130px;
  padding: 4px 0;
  font-size: 14px;
  cursor: pointer;
}
.add-related-line {
  height: 0px;
  border-top: 1px dashed var(--lineBorderColor);
  margin: 0 0 20px 30px;
}
</style>
